import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useListPartCategories = () =>
  useQuery(['listPartCategories'], async () => {
    const res = await api.get('/api/part-categories');
    return res.data.data;
  });
